import type * as stylex from '@stylexjs/stylex';
import { createLink } from '@tanstack/react-router';

import { Link, type LinkProps } from '@/libs/serenity-ui';

// createLink somehow affects the style property, so we need to use a custom property to pass the style property to the component.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const RouterLink = createLink(({ className, ...props }: Omit<LinkProps, 'style'> & { className?: string, _style?: stylex.StyleXStyles }) => <Link {...props} style={props._style} />);
